import React from 'react';
import { ArticleLinkCardStyle } from '../components/ArticleLinkCard';
import Article from '../models/Article';
import ArticleHeader from '../components/ArticleHeader';
import ArticleBody from '../components/ArticleBody';
import ArticleAuthorLink from '../components/ArticleAuthorLink';
import moment from 'moment';
import TitledArticleLinkCardList from '../components/TitledArticleCardList';
import ArticleLink from '../models/ArticleLink';
import Ad, { clearKeyValuePair, setKeyValuePair } from '@gik/ads/components/Ad';
import ZonesMap from '@gik/ads/maps/ZonesMap';
import { ArticleStructuredData } from '@gik/seo';

interface ArticlePageProps {
  article: Article;
  articleLinks: ArticleLink[];
}

export default function ArticlePage({ article, articleLinks }: ArticlePageProps) {
  React.useEffect(() => {
    setKeyValuePair(article.taxonomyItemName);

    return () => {
      clearKeyValuePair();
    };
  }, [article.taxonomyItemName]);

  const relatedArticleLinks = React.useMemo(
    () => articleLinks.filter(link => link.articleSlug !== article.articleSlug).slice(0, 4),
    [article.articleSlug, articleLinks]
  );

  return (
    <ArticleStructuredData article={article}>
      <article className="article-page">
        <div className="bs-padding-wrapper">
          <div className="bs-padding">
            <ArticleHeader article={article} />
            <section className="article-3-column section-1">
              <div className="column-1" />
              <div className="column-2">
                <div className="article-info">
                  <ArticleAuthorLink articleLink={article} />
                  <span className="separator">•</span>
                  <time
                    className="date"
                    dateTime={moment(article.date).format()}
                    title={moment(article.date).format('MMM DD YYYY')}
                  >
                    {moment(article.date).format('MMM DD')}
                  </time>
                </div>
                <div className="article-separator" />
                <ArticleBody article={article} />
                <div className="article-separator" />
                <p className="terms">
                  Give InKind does not provide medical advice, diagnosis, or treatment. We have an affiliate
                  relationship with many of the advertisers on our site, and may receive a commission from any products
                  purchased from links in this article. See <a href="/terms-service">Terms {'&'} Conditions</a>.
                </p>
              </div>
              <Ad
                zone={ZonesMap.ArticleZones.Right}
                className="column-3"
                adType="vertical"
                override={article.advertising}
              />
            </section>
            <Ad
              zone={ZonesMap.ArticleZones.Bottom}
              mobileZone={ZonesMap.ArticleZones.BottomMobile}
              override={article.advertising}
            />
            {relatedArticleLinks.length > 0 && (
              <div className="section-2">
                <TitledArticleLinkCardList
                  title={'Related Articles'}
                  articleLinks={relatedArticleLinks}
                  style={ArticleLinkCardStyle.small}
                />
              </div>
            )}
          </div>
        </div>
      </article>
    </ArticleStructuredData>
  );
}
